const locale = "ko-KR";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "YYYY. MM. DD.",
	dateTimeFormat: "YYYY. MM. DD. HH:mm",
	"serviceReports.headline": "서비스 보고서",
	"serviceReports.sublineMachine": "귀하의 기계에 대한 서비스 보고서들을 보고 다운로드하십시오.",
	"serviceReports.technicianName": "서비스 엔지니어 성명",
	"serviceReports.machineNameAndNumber": "기계 및 기계 번호",
	"serviceReports.startDate": "시작일",
	"serviceReports.endDate": "종료일",
	"serviceReports.creationDate": "작성일",
	"serviceReports.openReport": "서비스 보고서 열기 (PDF)",
	"serviceReports.filter": "필터",
	"serviceReports.missionNumber": "미션번호",
	"serviceReports.assignmentType": "서비스 보고서 종류",
	"serviceReports.reportTypes.IA": "설치 제거 / 재배치 리포트",
	"serviceReports.reportTypes.AC": "애플리케이션 컨설팅 리포트",
	"serviceReports.reportTypes.IV": "설치 준비 리포트",
	"serviceReports.reportTypes.BA": "평가 리포트",
	"serviceReports.reportTypes.UV": "안전 점검 리포트",
	"serviceReports.reportTypes.IG": "중고 기계 설치 리포트",
	"serviceReports.reportTypes.UB": "품질 측정 리포트",
	"serviceReports.reportTypes.PN": "생산 지원 리포트",
	"serviceReports.reportTypes.NR": "레트로핏 리포트",
	"serviceReports.reportTypes.IB": "설치 / 시작 보고서",
	"serviceReports.reportTypes.II": "설치 통합 리포트",
	"serviceReports.reportTypes.IC": "내부 수리 리포트",
	"serviceReports.reportTypes.MB": "박람회 서비스 리포트",
	"serviceReports.reportTypes.HW": "리소스 리포트",
	"serviceReports.reportTypes.TT": "엔지니어 교육 리포트",
	"serviceReports.reportTypes.SK": "고객 교육 보고서",
	"serviceReports.reportTypes.RP": "수리 보고서",
	"serviceReports.reportTypes.RW": "수리 보고서 및 유지보수 보고서",
	"serviceReports.reportTypes.WA": "유지보수 보고서",
	"serviceReports.reportTypesPlural.IA": "설치 제거 / 재배치 리포트들",
	"serviceReports.reportTypesPlural.AC": "애플리케이션 컨설팅 리포트들",
	"serviceReports.reportTypesPlural.IV": "설치 준비 리포트들",
	"serviceReports.reportTypesPlural.BA": "평가 리포트들",
	"serviceReports.reportTypesPlural.UV": "안전 점검 리포트들",
	"serviceReports.reportTypesPlural.IG": "중고 기계 설치 리포트들",
	"serviceReports.reportTypesPlural.UB": "품질 측정 리포트들",
	"serviceReports.reportTypesPlural.PN": "생산 지원 리포트들",
	"serviceReports.reportTypesPlural.NR": "레트로핏 리포트들",
	"serviceReports.reportTypesPlural.IB": "설치 / 시작 보고서들",
	"serviceReports.reportTypesPlural.II": "설치 통합 리포트들",
	"serviceReports.reportTypesPlural.IC": "내부 수리 리포트들",
	"serviceReports.reportTypesPlural.MB": "박람회 서비스 리포트들",
	"serviceReports.reportTypesPlural.HW": "리소스 리포트들",
	"serviceReports.reportTypesPlural.TT": "엔지니어 교육 리포트들",
	"serviceReports.reportTypesPlural.SK": "고객 교육 보고서들",
	"serviceReports.reportTypesPlural.RP": "수리 보고서",
	"serviceReports.reportTypesPlural.RW": "수리 및 유지보수 보고서",
	"serviceReports.reportTypesPlural.WA": "유지보수 보고서",
	"serviceReports.loadMore": "더 로드하기",
	"serviceReports.loadError": "데이터를 불러오는 중에 오류가 발생했습니다.",
	"serviceReports.noReportsFound": "현재 서비스 보고서가 존재하지 않습니다.",
	"serviceReports.noReportsAvailable": "현재 서비스 보고서가 존재하지 않습니다.",
	missingAuthorization: "권한 없음",
	"headline.createCase": "새로운 서비스 사례 생성",
	"headline.caseDetails": "케이스 상세 정보",
	"headline.contactData": "연락처 데이터",
	"field.reason.label": "문의 이유",
	"field.machine.label": "기계 및 기계 번호",
	"field.softwareProblemClassification.label": "문제 분류",
	"field.softwareInstallationProblem.label": "설치 문제",
	"field.softwareLicenseIssue.label": "라이센스 문제",
	"field.softwareType.label": "소프트웨어 유형",
	"field.softwareModule.label": "소프트웨어 모듈",
	"field.errorNumber.label": "에러 번호",
	"field.errorNumber.explanation": "예: 0000FC00, 1.10.58102409 또는 6000",
	"field.errorNumber.addAnotherNumber": "다른 에러 번호 추가",
	"field.errorNumber.errorMessage": "유효하지 않은 에러 번호",
	"field.message.label": "메시지",
	"field.message.placeholder": "귀하의 요청/문제를 가능한 한 구체적이고 필요한 만큼 자세히 설명하십시오(인사말 없이). 감사합니다.",
	"field.fileUpload.label": "첨부파일",
	"field.fileUpload.info": "허용되는 파일 형식: IMG, JPG, PNG, PDF, HTML, TruTops-파일 등 (최대 16 MB) 및 MP4 비디오 파일 (최대 50 MB)",
	"field.salutation.label": "성별",
	"field.salutation.male": "Mr.",
	"field.salutation.female": "Mrs.",
	"field.firstName.label": "이름",
	"field.lastName.label": "성",
	"field.email.label": "이메일",
	"field.phone.label": "전화번호",
	"button.submit": "전송",
	"button.cancel": "취소",
	"button.back": "뒤로",
	"button.next": "계속",
	"button.close": "닫기",
	"button.ok": "Ok",
	"auth.error": "예상치 못한 오류가 발생했습니다.",
	"select.placeholder": "선택하십시오 ...",
	"validation.requiredField": "이 입력창은 필수 입력창입니다.",
	"validation.invalidEmail": "유효한 전자메일 주소를 입력하십시오.",
	"validation.maxAllowedCharacters": "최대 허용 문자 수: {{number}}",
	"validation.requiredFieldsExplanation": "*표시는 필수 입력 필드입니다.",
	"validation.invalidPhoneNumber": "유효한 전화번호를 입력하십시오.",
	"softwareProblemClassification.standstill": "정지 상태",
	"softwareProblemClassification.fault": "장애",
	"softwareProblemClassification.slightImpairment": "가벼운 기능 저하",
	"softwareProblemClassification.generalInquiry": "일반 문의 사항",
	"serviceCase.proactiveCaseClosure.title": "피드백 & 케이스 종료 요청",
	"serviceCase.proactiveCaseClosure.instructions": "케이스 종료를 요청하고 예측 서비스를 개선하는 데 도움이 되도록 귀하의 피드백을 부탁드립니다.",
	"serviceCase.proactiveCaseClosure.question.submit": "전송",
	"serviceCase.proactiveCaseClosure.dialogTitle": "케이스 종료 요청됨. 피드백을 보내주셔서 감사합니다.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Ok",
	"serviceCase.proactiveCaseClosure.question.anomaly": "보고된 이상현상이 귀하의 기계에 존재했습니까?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Technical Guide가 제공되었습니까?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Technical Guide를 사용하여 문제를 직접 해결할 수 있었습니까?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "이러한 유형의 이상현상에 대한 알림을 일시중지하시겠습니까?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "얼마나 오랫동안 이러한 유형의 이상현상에 대한 알림을 일시중지하시겠습니까?",
	"serviceCase.proactiveCaseClosure.question.comment": "이러한 유형의 이상현상에 대한 알림을 일시중지하려는 이유를 설명해주십시오:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "케이스 종료를 요청하고 피드백을 전송하려면 코멘트가 필요합니다",
	"serviceCase.proactiveCaseClosure.answers.yes": "예",
	"serviceCase.proactiveCaseClosure.answers.no": "아니오",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7일",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14일",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30일",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90일",
	"sisConnector.success.headline": "서비스 사례가 성공적으로 생성되었습니다.",
	"sisConnector.success.orderNumberRequired.title": "참고:",
	"sisConnector.success.orderNumberRequired.text": "케이스 세부정보 페이지에서 케이스 청구 및 기타 서비스를 위해 주문번호를 추가하십시오.",
	"sisConnector.success.technicalGuide.title": "이 에러 번호에 대한 기술 가이드를 사용할 수 있습니다.",
	"sisConnector.success.technicalGuide.text": "입력한 에러 번호로 한 개 이상의 기술 가이드를 결정할 수 있습니다. 이제 50% 정도의 케이스를 스스로 해결하실 수 있습니다. 이 기능은 해당 서비스 계약에 한해 사용할 수 있습니다.",
	"sisConnector.success.outsideOfServiceHours": "당사 서비스 시간이 아닌 시간에 생성된 케이스는 처리되지 않는다는 점에 유의하십시오.",
	"sisConnector.success.serviceTimes.MonFri": "당사 서비스 시간: 월요일-금요일",
	"sisConnector.success.serviceTimes.Sat": "및 토요일",
	"sisConnector.success.withTechnicalServiceHotline": "즉각적인 도움이 필요한 경우 TRUMPF 고객 기술 서비스({{hotline}})에 전화하여 지원을 요청하십시오.",
	"sisConnector.success.withoutTechnicalServiceHotline": "즉시 도움이 필요할 경우 TRUMPF 기술 서비스 부서에 전화하여 지원을 요청하십시오.",
	"sisConnector.success.caseId": "Case ID",
	"sisConnector.failed.headline": "서비스 케이스(사례)를 생성할 수 없었습니다.",
	"sisConnector.failed.unknownError": "다시 시도하거나 귀사의 지원팀에 문의하십시오."
};
var koKR = {
	locale: locale,
	translations: translations
};

export { koKR as default, locale, translations };
//# sourceMappingURL=ko-KR-DCI5Jgps.js.map

//# sourceMappingURL=ko-KR-DCI5Jgps.js.map